<template>
  <div class="vt-map">
    <div class="vt-map__graph">
      <div
        id="map"
        ref="map"
        class="vt-map__map"
      >
        <!-- Panel default -->
        <div
          :class="['vt-map__panel vt-map__panel--flutuant',
                   panelOpened ? 'vt-map__panel--opened' : 'vt-map__panel--closed']"
          @mouseenter="dragging(false)"
          @mouseleave="dragging(true)"
        >
          <div class="panel-content">
            <div class="top">
              <span
                ref="addresses"
                class="sr-only"
                tabindex="-1"
              >Lista de endereços</span>
              <ul
                v-if="addresses && showAddresses"
                class="addresses"
                role="list"
              >
                <li
                  v-for="item in addresses"
                  :key="item.Id"
                  role="listitem"
                  tabindex="0"
                  :class="['link', { 'link--selected': address && address.Id == item.Id }]"
                  @keyup.enter="onClickAddress(item)"
                  @click="onClickAddress(item)"
                >
                  <map-v2-info
                    :address="item"
                  />
                </li>
                <li role="listitem">
                  <a
                    href="#"
                    class="sr-only"
                    title="Clique para voltar para o menu"
                    @click.prevent="onClickBackToMenu"
                  />
                </li>
              </ul>
            </div>
            <div class="bottom">
              <ul
                v-if="categories"
                ref="categories"
                class="categories"
                tabindex="0"
                aria-label="map"
                role="menu"
                aria-expanded="true"
                @focus="onFocusCategories"
              >
                <li
                  v-if="isMultipleCategories"
                  role="menuitem"
                >
                  <a
                    :class="['link', { 'link--selected': !category }]"
                    href="#"
                    @click.prevent="onClickCategory()"
                  >
                    <span>{{ allSelect.text }}</span>
                  </a>
                </li>
                <li
                  v-for="item in categories"
                  :key="item.Id"
                  role="menuitem"
                >
                  <a
                    :class="['link', { 'link--selected': category && category.Id == item.Id || !isMultipleCategories }]"
                    href="#"
                    @click.prevent="onClickCategory(item)"
                  >
                    <img
                      v-if="item.Icon"
                      :src="item.Icon"
                      alt=""
                    >
                    <span>{{ item.Description }}</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <a
            href="#"
            :class="['button-toogle', { 'button-toogle--closed': !panelOpened }]"
            tabindex="0"
            :aria-label="getAriaLabel()"
            @click.prevent="panelOpened = !panelOpened"
          >
            <svg v-if="panelOpened">
              <use xlink:href="#chevron-left" />
            </svg>
            <svg v-else>
              <use xlink:href="#icon-hamburguer" />
            </svg>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import L from 'leaflet'
import 'leaflet-fullscreen'
import 'leaflet-active-area'
import _ from 'lodash'
import api from './api'
import MapV2Info from './map-v2-info.vue'

export default {
  name: 'MapV2',
  components: {
    MapV2Info,
  },
  props: {
    icon: {
      type: String,
      default: 'https://img.icons8.com/ios-filled/64/000000/cancel.png'
    },
    urlAjax: {
      type: String,
      required: true
    },
    urlTiles: {
      type: String,
      default: 'https://assets.cbmm.com/assets/niobium/images/map'
    },
    i18n: {
      type: Object,
      default() {
        return {
          allCategories: 'All Categories'
        }
      }
    }
  },
  data() {
    return {
      map: null,
      categories: null,
      category: undefined,
      address: null,
      panelInfoOpened: false,
      panelOpened: true,
      isMobile: true,
      showAddresses: true,
      height: null,
      allSelect: {
        text: this.i18n.allCategories
      },
      language: ''
    }
  },
  computed: {
    isMultipleCategories() {
      return this.categories && this.categories.length > 1
    },
    theY() {
      return `${this.height}px`
    },
    addresses() {
      if (this.category) {
        return this.category.Addresses
      }
      return _.reduce(this.categories, (memo, category) => {
        memo = memo.concat(category.Addresses)
        return memo
      }, [])
    }
  },
  watch: {
    category(value) {
      this.changeCategory(value)
    }
  },
  created() {
    Object.assign(api.options, {
      url: this.urlAjax
    })

    this.getDataSource()

    this.isMobile = this.checkIsMobile()
    this.panelOpened = !this.isMobile
  },
  mounted() {
    this.map = L.map('map', {
      scrollWheelZoom: false,
      worldCopyJump: true,
      // zoomSnap: 0.50,
      fullscreenControl: true,
      doubleClickZoom: false,
      dragging: !L.Browser.mobile,
      tap: !L.Browser.mobile
    }).setActiveArea({
      position: 'absolute',
      top: '10px',
      right: '10px',
      bottom: '10px',
      left: this.isMobile ? '10px' : '340px'
    }).setView([51.505, -0.09], 3)

    L.tileLayer(`${this.urlTiles}/{z}/{x}/{y}.jpg`, {
      maxZoom: 5,
      minZoom: this.isMobile ? 0 : 1,
      detectRetina: true
    }).addTo(this.map)
  },
  methods: {
    changeCategory(value) {
      _.each(this.categories, (item) => {
        if (value && item.Id === value.Id) {
          item.layerGroup.addTo(this.map)
        } else if (value && item.Id !== value.Id) {
          item.layerGroup.remove(this.map)
        } else if (!value && !this.map.hasLayer(item.layerGroup)) {
          item.layerGroup.addTo(this.map)
        }
      })

      if (this.address) {
        this.markerSize(this.address, false)
      }

      if (value) {
        this.map.fitBounds(value.layerGroup.getBounds())
      } else {
        this.map.fitBounds(this.allSelect.bounds)
      }
    },
    dragging(drag) {
      if (this.isMobile) return

      if (drag) {
        this.map.dragging.enable()
      } else {
        this.map.dragging.disable()
      }
    },
    onCloseInfo() {
      const selected = this.$el.querySelector('.addresses .link--selected')
      selected.focus()

      this.markerSize(this.address, false)
    },
    checkIsMobile() {
      return (/(Android|iPod|iPhone|iPad|BlackBerry|Windows Phone|IEMobile)/ig).test(navigator.userAgent)
    },
    onFocusCategories() {
      this.showAddresses = false
    },
    onClickBackToMenu() {
      const { categories } = this.$refs
      categories.focus()
    },
    tooglePanel() {
      this.panelOpened = !this.panelOpened
    },
    toogleInfoPanel() {
      this.panelInfoOpened = !this.panelInfoOpened
    },
    markerSize(address, isOpen) {
      const { icon } = address.marker.options

      icon.options.iconSize = isOpen ? [40, 40] : [24, 24]
      address.marker.setIcon(icon)

      if (isOpen) {
        address.marker.setZIndexOffset(9999)
      } else {
        address.marker.setZIndexOffset(address.marker.defautzIndex)
      }
    },
    onClickAddress(address) {
      this.onClickMarker(address, true)

      if (this.isMobile) {
        this.panelOpened = false
      }
    },
    onClickMarker(address, realign) {
      if (realign) {
        // fly, pan, setView
        this.map.flyTo(address.marker.getLatLng(), 3)
      }

      // To close last
      if (this.address) {
        this.markerSize(this.address, false)
      }

      this.markerSize(address, true)

      this.address = address

      window.dataLayer.push({
        event: 'click',
        name: address.Title,
        section: 'Presença Global',
        component_type: 'mapa',
        outbound: false
      })
    },
    createMarker(category, address, index) {
      const { Latitude, Longitude } = address

      const Icon = L.Icon.extend({
        options: {
          iconSize: [24, 24]
        }
      })

      const icon = new Icon({
        iconUrl: category.Icon ? category.Icon : this.icon
      })

      const marker = L.marker([Latitude, Longitude], {
        keyboard: false,
        icon
      })

      marker.defautzIndex = (this.categories.length - index) * 100
      marker.setZIndexOffset(marker.defautzIndex)

      marker.bindPopup(address.Title)

      marker.on('mouseover', () => {
        marker.openPopup()
      })

      marker.on('mouseout', () => {
        marker.closePopup()
      })

      return marker.on('click', () => {
        this.onClickMarker(address, false)
        this.panelInfoOpened = true
      })
    },
    onClickCategory(category) {
      if (this.category && this.category.Id === category) {
        this.category = null
      } else {
        this.category = category
      }
      this.showAddresses = true

      this.$nextTick(() => {
        const { addresses } = this.$refs
        addresses.focus()
      })
    },
    createLayers() {
      const markers = []

      _.each(this.categories, (categorie, index) => {
        const groupList = []

        _.each(categorie.Addresses, (address) => {
          address.marker = this.createMarker(categorie, address, index)
          groupList.push(address.marker)
          markers.push(address.marker)
        })

        categorie.layerGroup = L.featureGroup(groupList)
      })

      this.allSelect.bounds = new L.featureGroup(markers).getBounds() // eslint-disable-line

      this.changeCategory()
    },
    getDataSource() {
      api.get().then((data) => {
        if (data && data.length) {
          this.categories = data
          this.createLayers()
        }
      })
    },
    getAriaLabel() {
      if (this.panelOpened) {
        return this.language === 'pt' ? 'Abrir painel' : 'Open panel'
      // eslint-disable-next-line no-else-return
      } else {
        return this.language === 'pt' ? 'Fechar painel' : 'Close panel'
      }
    }
  }
}
</script>

<style lang="scss">
  .vt-map {
    display: flex;
    position: relative;
    background: $white;

    &__panel {
      $container: &;
      display: flex;
      z-index: 9999;
      height: 100%;
      position: relative;

      & .panel-content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 100%;
        overflow: hidden;
        background: $white;
        gap: 1.5rem;

        & .bottom {
          & .categories {
            margin: 0;
            padding: 0;

            li {
              display: flex;
              font-family: "Montserrat", sans-serif;

              & .link {
                display: flex;
                align-items: center;
                gap: 0.5rem;
                width: 100%;
                padding: 0 0 1rem 1rem;
                text-decoration: none;
                color: $black;
                font-size: 0.875rem;
                font-weight: 500;

                & img {
                  width: 1.5rem;
                  height: 1.5rem;
                }

                &--selected {
                  font-weight: 700;
                }
              }
            }

          }
        }

        & .top {
          overflow: auto;
          scrollbar-width: none;

          & .addresses {
            font-family: "Montserrat", sans-serif;
            margin: 0;
            padding: 0 1rem;

            & > li {
              padding: 1rem 1rem 1.813rem;
              font-size: 0.875rem;

              &:hover {
                cursor: pointer;
              }

              &:not(:last-child) {
                border: 0.063rem solid $blue-06;
                min-height: 15.313rem;
              }

              & .info {
                &__title {
                  font-weight: 500;
                  font-size: 0.875rem;
                  margin-bottom: 1.25rem;
                  color: $neutral-01;
                  line-height: 120%;
                }

                &__body {
                  display: flex;
                  flex-direction: column;
                  font-size: 0.75rem;
                  color: $neutral-02;
                  line-height: 120%;

                  & > div {
                    display: grid;
                    gap: .5rem;
                    grid-template-columns: repeat(2, auto);
                    justify-content: start;

                    &:not(:last-of-type) {
                      margin-bottom: 1rem;
                    }

                    & img {
                      width: 1.5rem;
                      height: 1.5rem;
                      margin-right: 0.625rem;
                    }

                    & .link {
                      display: flex;
                      align-items: center;
                      padding: 0.313rem 0.625rem;
                      font-weight: 600;
                      text-decoration: none;

                      & > img {
                        width: 1rem;
                        height: 1rem;
                        margin: 0 0 0 0.625rem;
                      }

                      &--decorated {
                        color: $blue-04;
                        border: 0.125rem solid $blue-04;
                        border-radius: 0.5rem;
                        font-weight: normal;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }

      & .button-toogle {
        display: none;
        height: 2.313rem;
        align-items: center;
        justify-content: center;

        &:hover {
          cursor: pointer;
        }

        & svg {
          width: 2.313rem;
          height: 2.313rem;
          padding: 0.75rem;
          border-radius: 0.125rem;
          background-color: $white;
          border: 0.063rem solid $blue-06;
        }

        &--closed {
          border-radius: 0.125rem;
          margin-left: 0.625rem;

          & svg {
            padding: 0.5rem;
          }
        }
      }

      &--flutuant {
        position: absolute;
        left: 0;

        & .button-toogle {
          display: flex;
        }
      }

      &--closed {
        width: 0;

        & .button-toogle--hidden {
          display: none;
        }
      }

      &--opened {
        width: calc(100% - 3.438rem);

        @media (min-width: 600px) {
          width: 17.188rem;
        }
      }
    }

    &__graph {
      width: 100%;
      padding-top: 1rem;
    }
  }
</style>
